import React, { Component } from 'react';
import LeftSection from './LeftSection.js';

class Workshops extends Component {
  render() {
    return (
        <div id="workshops" className="page page3 workshops"> 
            <LeftSection /> 
        </div>
    );
  }
}

export default Workshops;